var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "main-content" },
    [
      _c(
        "el-header",
        [
          _c(
            "span",
            { staticClass: "op-left" },
            [
              _c("label", [_vm._v("产品型号：")]),
              _vm._v(" "),
              _c(
                "el-select",
                {
                  staticClass: "el-select el-select-group",
                  model: {
                    value: _vm.defaultProduct,
                    callback: function ($$v) {
                      _vm.defaultProduct = $$v
                    },
                    expression: "defaultProduct",
                  },
                },
                _vm._l(_vm.productList, function (op, value) {
                  return _c("el-option", {
                    key: value,
                    attrs: { label: op.text, value: op.value },
                  })
                }),
                1
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  staticClass: "el-button--primary",
                  on: { click: _vm.queryTestList },
                },
                [_vm._v("获取用例")]
              ),
              _vm._v(" "),
              _c("label", [_vm._v("测试设备：")]),
              _vm._v(" "),
              _c(
                "el-select",
                {
                  staticClass: "el-select el-select-group",
                  model: {
                    value: _vm.defaultDevice,
                    callback: function ($$v) {
                      _vm.defaultDevice = $$v
                    },
                    expression: "defaultDevice",
                  },
                },
                _vm._l(_vm.deviceList, function (op, value) {
                  return _c("el-option", {
                    key: value,
                    attrs: { label: op.text, value: op.value },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "el-button--primary",
              on: { click: _vm.connectDevice },
            },
            [_vm._v("连接")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "el-button--info",
              on: { click: _vm.disconnectDevice },
            },
            [_vm._v("断开")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "el-button--primary add-btn",
              on: { click: _vm.testStart },
            },
            [_vm._v("开始测试")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "el-button--info add-btn",
              on: { click: _vm.testStop },
            },
            [_vm._v("结束测试")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        { attrs: { data: _vm.testItemList, stripe: "", border: "" } },
        [
          _c("el-table-column", {
            attrs: { prop: "id", label: "序号", align: "center" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "name", label: "用例名称", align: "center" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "model", label: "产品型号", align: "center" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "content", label: "测试命令", align: "center" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "manual",
              label: "是否人工判断",
              formatter: _vm.formatBoolean,
              align: "center",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "step", label: "测试步骤", align: "center" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "preResult", label: "预期结果", align: "center" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "realResult",
              label: "实际结果(人工填写)",
              hidden: "",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.manual
                      ? _c("el-input", {
                          staticClass: "el-input--small",
                          staticStyle: { width: "auto" },
                          attrs: { placeholder: "结果数据" },
                          model: {
                            value: scope.row.realResult,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "realResult", $$v)
                            },
                            expression: "scope.row.realResult",
                          },
                        })
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { fixed: "right", label: "操作" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.manual === false
                      ? _c(
                          "el-button",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.testIt(scope.row)
                              },
                            },
                          },
                          [_vm._v("自动测试")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    scope.row.manual
                      ? _c(
                          "el-button",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.testManualStart(scope.row)
                              },
                            },
                          },
                          [_vm._v("人工测试")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    scope.row.manual
                      ? _c(
                          "el-button",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.testManualDone(scope.row)
                              },
                            },
                          },
                          [_vm._v("测试结果提交")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("label", [_vm._v(_vm._s(scope.row.opResult))]),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }